import { Controller } from "@hotwired/stimulus"

// Learner document language switch. Turbo Drive is off, so the pills set the
// nested turbo-frame's src (the same trick File Hub chips use) and keep the
// URL shareable with history.replaceState.
export default class extends Controller {
  connect() {
    this.frame = document.getElementById("academy_document_language")
    this.onFrameLoad = this.focusActivePill.bind(this)
    this.frame?.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    this.frame?.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  select(event) {
    event.preventDefault()
    const url = event.currentTarget.getAttribute("href")
    if (!url) return

    if (this.frame) this.frame.src = url
    history.replaceState({}, "", url)

    const locale = new URL(url, window.location.origin).searchParams.get("lang")
    if (locale) this.element.lang = locale
  }

  focusActivePill() {
    this.element.querySelector(".academy-reader-language-pill.is-active")?.focus()
  }
}
